var _path, _path2, _path3, _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 172,
    viewBox: "0 0 88 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 156L72 64C72 57.3726 66.6274 52 60 52L24 52C17.3726 52 12 46.6274 12 40L12 12",
    stroke: "#36827B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 155L72 152",
    stroke: "#36827B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 148L72 156L64 148",
    stroke: "#36827B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#36827B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 0.6,
    width: 22.8,
    height: 22.8,
    rx: 11.4,
    transform: "matrix(-1 0 0 1 22.8 0)",
    stroke: "#36827B",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.6,
    cy: 3.6,
    r: 2.7,
    transform: "matrix(-1 0 0 1 15.5996 8.3999)",
    fill: "white",
    stroke: "#36827B",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFlow);
export default __webpack_public_path__ + "static/media/left-flow.8a166ba163240acbe778b4833185e2db.svg";
export { ForwardRef as ReactComponent };